import { render, staticRenderFns } from "./punchingMenu.vue?vue&type=template&id=117e1680&"
import script from "./punchingMenu.vue?vue&type=script&lang=js&"
export * from "./punchingMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports